/**
 * アコーディオン（.js-accordion-btn / .js-accordion-content）
 * RPO FAQ: カード全体をクリックで開閉（プラス/マイナスは装飾）
 */
export function init() {
	if (typeof window.$ === 'undefined') return;
	const $ = window.$;
	$('.js-accordion-btn').append('<span class="btn"></span>');
	$('.js-accordion-btn').on('click', function () {
		if ($(this).closest('.rpoFaq__item').length) return; // RPOは .rpoFaq__item で一括処理
		$(this).next('.js-accordion-content').slideToggle();
		$(this).toggleClass('is-open');
	});
	// RPO FAQ: エリア全体クリックで開閉（吹き出し・イラストはフェードでなめらかに）
	$('.rpoFaq__list').on('click', '.rpoFaq__item', function () {
		const $item = $(this);
		const $content = $item.find('.js-accordion-content');
		const isOpening = $content.is(':hidden');
		$item.find('.js-accordion-btn').toggleClass('is-open');
		if (isOpening) {
			$content.removeClass('is-visible');
			$content.slideDown(280, function () {
				const $c = $(this);
				requestAnimationFrame(function () {
					$c.addClass('is-visible');
				});
			});
		} else {
			$content.removeClass('is-visible');
			setTimeout(function () {
				$content.slideUp(280, function () {
					$content.removeClass('is-visible');
				});
			}, 200);
		}
	});
}
